import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LearnosityApi } from '../+api';
import {
  IntermediateReportInterface,
  LearnosityItemsApiInterface,
  LearnosityItemsConfigInterface,
  LearnosityItemsSettingsInterface,
} from '../+external-interfaces';
import { ContextInterface } from '../+models';

@Injectable({ providedIn: 'root' })
export class LearnosityAssessmentApiService implements LearnosityItemsApiInterface {
  private learnosityApi = inject(LearnosityApi);

  getLearnosityItemsConfig(
    eduContentId: number,
    learnosityReference: string,
    sessionId: string,
    options: { settings?: LearnosityItemsSettingsInterface; context?: ContextInterface; itemReferences?: string[] } = {}
  ): Observable<LearnosityItemsConfigInterface> {
    const { itemReferences, settings, context } = options;
    return this.learnosityApi.buildItemsRequest(
      eduContentId,
      learnosityReference,
      sessionId,
      itemReferences,
      settings,
      context
    );
  }

  getLearnosityLocalItemsConfig(
    eduContentId: number,
    learnosityReference: string,
    options: { settings?: LearnosityItemsSettingsInterface; itemReferences?: string[] } = {}
  ): Observable<LearnosityItemsConfigInterface> {
    const { itemReferences, settings } = options;
    return this.learnosityApi.buildLocalItemsRequest(eduContentId, learnosityReference, itemReferences, settings);
  }

  getIntermediateReport(
    learnosityInitResponse: LearnosityItemsConfigInterface
  ): Observable<IntermediateReportInterface> {
    const { session_id: sessionId, user_id: userId, activity_id: activityId } = learnosityInitResponse.request!;
    return this.learnosityApi.getIntermediateReport(sessionId!, userId!, activityId!);
  }

  buildGradingRequest(studentId?: number): Observable<LearnosityItemsConfigInterface> {
    return this.learnosityApi.buildGradingRequest(studentId);
  }

  exerciseStarted(
    sessionId: string,
    userId: string,
    activityId: string,
    eduContentId: number,
    registrationId?: number
  ): Observable<any> {
    return this.learnosityApi.exerciseStarted(sessionId, userId, activityId, eduContentId, registrationId);
  }

  exerciseCompleted(
    sessionId: string,
    userId: string,
    activityId: string,
    eduContentId: number,
    registrationId?: number
  ): Observable<any> {
    return this.learnosityApi.exerciseCompleted(sessionId, userId, activityId, eduContentId, registrationId);
  }

  exerciseDiscarded(
    sessionId: string,
    userId: string,
    activityId: string,
    eduContentId: number,
    registrationId?: number
  ): Observable<any> {
    return this.learnosityApi.exerciseDiscarded(sessionId, userId, activityId, eduContentId, registrationId);
  }

  itemAnswered(
    sessionId: string,
    userId: string,
    activityId: string,
    eduContentId: number,
    registrationId?: number,
    itemReference?: string
  ): Observable<any> {
    return this.learnosityApi.itemAnswered(sessionId, userId, activityId, eduContentId, registrationId, itemReference);
  }
}
